module.exports = __webpack_public_path__ + "img/mail.ca1f4b36.svg";